<button
  [attr.id]="id"
  [attr.name]="name ?? id"
  [attr.tabindex]="!isDisabled ? tabIndex : null"
  [attr.type]="type"
  [disabled]="isDisabled"
  avoidMulticlick
  (safeClick)="onSafeClick($event)">
  <div class="c-button__content-wrapper">
    <span class="c-button__left-bullet">
      <ng-content select="[buttonBullet] [buttonBulletPos=left]"></ng-content>
    </span>

    <span class="c-button__content">
      @if (isLoading) {
        <div class="is-loading">
          <slotcom-loading class="centered"></slotcom-loading>
        </div>
      } @else {
        <ng-content></ng-content>
      }
    </span>

    <span class="c-button__right-bullet">
      <ng-content select="[buttonBullet] [buttonBulletPos=right]"></ng-content>
    </span>
  </div>
</button>
